import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../ducks/state"
import {getReadOnMainSite, pathToVipSite, updateReadOnMainSite} from "../../utils/nextSaleBagWarning"

const textSelector = createSelector(
    (state: State) => state.text,
    text => {
        const {title, textOne, textTwo, primaryButtonText, secondaryButtonText} = text.saleBagWarning
        return {title, textOne, textTwo, primaryButtonText, secondaryButtonText}
    },
)

export const mapStateToProps = (state: State) => {
    const {siteUrl} = state.request
    const openModal = getReadOnMainSite()

    return {
        openModal,
        siteUrl,
        text: textSelector(state),
        vipSitePath: pathToVipSite(siteUrl),
    }
}

export const mapDispatchToProps = () => ({
    remainOnMainSiteAction: () => {
        updateReadOnMainSite()
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
